import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
	position: relative;
	width: 100%;
	border: 0.01em solid #000000;
	display: flex;
	align-items: center;
	background-color: #ffffff;

	.job-results-logo {
		padding: 1em;
		min-width: 10em;
		max-width: 10em;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
	}
	.job-result-logo-img {
		object-fit: scale-down;
	}
	.content {
		width: 100%;
		border-left: 0.01em solid #000000;
		padding: 3em 3em 2em;

		.job-results-txt {
			display: flex;
			width: 100%;
			justify-content: space-between;
			font-size: 1.1em;
			color: #000000;

			.job-results-position {
				text-decoration: none;
				width: 50%;
				color: #000000;
				.job-results-name {
					font-size: 1.25em;
					font-weight: 700;
					color: #000000;
				}

				> * {
					&:not(:last-child) {
						margin-bottom: 0.62em;
					}
				}
			}

			.job-results-details {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				align-items: flex-end;

				.job-results-details-txt {
					display: flex;
					justify-content: flex-end;
					gap: 1.87em;
					.job-results-place {
						text-transform: capitalize;
					}
				}

				.job-results-action {
					display: flex;
					justify-content: flex-end;
					gap: 1.87em;

					.job-results-btn {
						.button {
							padding: 0;
						}
					}
				}
			}
		}

		.link {
			padding-top: 2em;
			display: flex;
			justify-content: flex-end;
			align-items: flex-end;
			gap: 1em;

			.job-results-meta {
				display: flex;
				flex-direction: column;
				gap: 0.2em;
				margin-right: auto;

				.job-results-date,
				.job-results-source {
					font-size: 0.95em;
					color: #666666;
				}

				.job-results-source {
					font-size: 0.85em;
				}
			}
		}
	}

	.offer-belt {
		position: absolute;
		width: 100%;
		top: -5%;
		left: 26%;
		transform: translate(-50%, -5%);
		background-repeat: no-repeat;
		background-position: center;
		font-weight: 700;

		display: flex;
		justify-content: center;
		align-items: center;

		.icon {
			margin-right: 0.5em;
		}
	}

	@media all and (max-width: ${variables.tabletS}) {
		.job-results-logo {
			max-width: 8.5em;
		}

		.content {
			.job-results-txt {
				gap: 0.5em;
				padding: 1.25em 1.5em;

				.job-results-name {
					text-overflow: ellipsis;
					max-width: 15ch;
					overflow: hidden;
					white-space: nowrap;
				}

				.job-results-details {
					gap: 1em;
					width: 100%;

					.job-results-details-txt {
						justify-content: flex-start;
						flex-wrap: wrap;
						gap: 1em;
					}

					.job-results-action {
						margin-left: auto;

						.job-results-save {
							position: absolute;
							top: 1.25em;
							right: 1.25em;
						}

						.job-results-btn-txt {
							display: none;
						}
					}
				}
			}
		}
	}

	@media all and (max-width: ${variables.tabletL}) {
		.job-results-logo {
			width: 7.5em;
			min-width: unset;
			padding: 1.75em;
		}

		.content {
			padding: 1.5em 1em 1em;

			.job-results-txt {
				flex-direction: column;
				gap: 0.5em;
				padding: 0;

				.job-results-position {
					.job-results-company {
						font-size: 1.1em;
					}
					.job-results-contract {
						display: none;
					}
				}

				.job-results-details {
					gap: 1em;
					align-items: flex-start;
					font-size: 1.1em;
					.job-results-action {
						margin-left: 0;

						.job-results-btn {
							.button {
								.button-content {
									display: none;
								}
							}
						}
					}
				}
			}
		}
	}

	@media all and (max-width: ${variables.mobileL}) {
		.offer-belt {
			left: 50%;
		}

		.content {
			.job-results-txt {
				.job-results-position {
					width: 100%;
				}
                .job-results-name {
                    max-width: 24ch;
                }
			}

            .offer-details {
                position: absolute;
                bottom: 3.2em;
                right: 2em;
            }
		}
        .job-results-logo {
            padding: 0.8em;
        }
	}
`;
